import {ReactElement} from 'react';
import {useSelector} from 'react-redux';
import {twMerge} from 'tailwind-merge';

import {selectLayoutType} from 'App/layout/layoutSlice';
import {LAYOUT_TYPES} from '~/components/common/pages_constants';

type TProps = {
  content: ReactElement;
  reparentableMap: ReactElement;
};

const LandingTemplate = ({content, reparentableMap}: TProps): ReactElement => {
  const layoutType = useSelector(selectLayoutType);
  return (
    <>
      {content}
      <div
        className={twMerge(
          layoutType === LAYOUT_TYPES.HIDDEN &&
            'fixed top-0 -z-10 h-[1000px] w-[1000px] overflow-hidden opacity-0',
        )}
      >
        {reparentableMap}
      </div>
    </>
  );
};

export default LandingTemplate;
